
export default {
    name: "PlatformOpenServiceAudit",
	conditionData:'',
	mounted: function () {
       this.init();
	},
    data() {
        return {
			edit: true,
            openServiceAuditForm: {
                id: '',
                version: '',
                // 客户公司名称
                companyName: '',
                // 0: 收单服务 1：出单服务
                applyService: '',
                // 服务特色
                serviceFeatures: '',
                // 业务需求
                businessRequire: '',
                // 审核意见
                auditOpinion: '',
                // 审核结果
                auditResult : null
            }
        }
    },
    created() {
    },
    computed: {
        rules() {
            return {
                auditOpinion: [
                    {max: 100, message: this.$t('p_openServiceAudit.message.tooLong') + 100, trigger: 'blur'}
                ],
                auditResult: [
                    {required: true, message: this.$t('p_openServiceAudit.message.auditRes'), trigger: 'change'}
                ]
            }
        },
    },
    methods: {
		init(){
			this.conditionData = this.$routerUtil.getParam();
			this.$routerUtil.clearParam();
			if(this.conditionData.row){
				this.openServiceAuditForm = this.conditionData.row;
            }
		},
        submitForm(formName) {
            console.log(this.$refs[formName], this.$refs);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const param = Object.assign({}, param, this.openServiceAuditForm);
                    console.log(param);
                    this.$axios.post('/api/customerCompay/companyApplyServiceExamine', param).then(response => {
                        let type = 'error';
                        if (response.data.status === '1') {
                            type = 'success';
                            this.doCancel();
                        }
                        this.$message({
                            message: this.$t(response.data.message),
                            type: type,
                            duration: 10000,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                }
            });
        },
		doCancel(){
            this.$routerUtil.setParam(this.conditionData.searchForm);
            this.$router.back();
		}
    }
}
